<p>blank works!</p>

<ng-container *ngIf="auth.isAuthenticated$ | async; then loggedIn else NotloggedIn"> </ng-container>

<ng-template #loggedIn>

    <button mat-flat-button id="qsLoginBtn" color="primary" (click)="logout()">
        <mat-icon>lock</mat-icon>&nbsp;<span>Log Out</span>
    </button>

</ng-template>

<ng-template #NotloggedIn>

    <button mat-flat-button id="qsLoginBtn" color="primary" (click)="auth.loginWithRedirect()">
        <mat-icon>lock</mat-icon>&nbsp;<span>Log In</span>
    </button>

</ng-template>